module.exports = __webpack_public_path__ + "img/tata_thumbnail.826a5037.png";